<div class="form-group d-flex">
    <input class="checkbox-input" *ngIf="isControlVisible()" [id]="getControlName()" [name]="getControlName()" [ngModel]="getValue()" (ngModelChange)="setValue($event)"
        [indeterminate]="isIndeterminate()" type="checkbox" kendoCheckBox />
    <kendo-label *ngIf="isLabelVisible()" class="k-checkbox-label" [for]="getControlName()" [text]="getLabel()">
    </kendo-label>
</div>